const SKIP_REASONS: Record<string, string> = {
	unsupported_origin: "Linear created this thread, so no customer asked",
	thread_not_completed: "the thread was reopened",
	no_contact_email: "the contact has no email address",
	contact_suppressed: "the contact's email bounced or is suppressed",
	contact_unsubscribed: "the contact unsubscribed from updates",
	blocked_sender: "the contact is a blocked sender",
	outbound_unavailable: "outbound email is not set up for this workspace",
	no_slack_channel: "the thread has no Slack channel to reply in",
	no_teams_conversation: "the thread has no Teams conversation to reply in",
	item_not_completed: "the issue or project is no longer in a completed status",
	status_unknown: "the Linear status could not be read",
	status_not_chosen: "this status is not one of your released statuses",
	stale_ship: "the work completed more than an hour ago",
	thread_too_old: "the customer last wrote more than 180 days ago",
	human_replied: "a teammate already replied after it was released",
	thread_cooldown: "this thread got a follow-up in the last 10 minutes",
	no_public_wording: "the item has no public title",
	unresolved_tokens: "the template has a placeholder that could not be filled",
	channel_unavailable: "the message could not be delivered",
	send_failed: "sending failed after several tries",
	not_live:
		"the linked pull request was not merged and deployed within 30 minutes",
}

export const closeLoopSkipLabel = (reason: string) =>
	SKIP_REASONS[reason] ?? reason.replaceAll("_", " ")

export const closeLoopSentLine = ({
	identifier,
	channel,
	recipient,
}: {
	identifier?: string
	channel: "email" | "slack" | "teams" | "live_chat" | "custom"
	recipient?: string
}) => {
	const item = identifier ? ` for ${identifier}` : ""
	const to = recipient ? ` to ${recipient}` : ""
	if (channel === "slack") return `Follow-up${item} sent in Slack`
	if (channel === "teams") return `Follow-up${item} sent in Teams`
	if (channel === "custom") return `Follow-up${item} sent to your integration`
	if (channel === "live_chat") {
		return `Follow-up${item} sent in live chat and by email${to}`
	}
	return `Follow-up${item} sent by email${to}`
}

export const closeLoopSkippedLine = ({
	identifier,
	reason,
}: {
	identifier?: string
	reason: string
}) =>
	`Follow-up${identifier ? ` for ${identifier}` : ""} not sent: ${closeLoopSkipLabel(reason)}`
